import IcUrology from "../images/urology.svg";
import IcNeurology from "../images/neurology.svg";
import IcOrthopedic from "../images/orthopedic.svg";
import IcCardiologist from "../images/cardiologist.svg";
import IcDentist from "../images/dentist.svg";

const spescialities = [
  {
    name: "Urology",
    icon: IcUrology,
    jmlDoctor: 21,
  },
  {
    name: "Neurology",
    icon: IcNeurology,
    jmlDoctor: 18,
  },
  {
    name: "Orthopedic",
    icon: IcOrthopedic,
    jmlDoctor: 17,
  },
  {
    name: "Cardiologist",
    icon: IcCardiologist,
    jmlDoctor: 12,
  },
  {
    name: "Dentist",
    icon: IcDentist,
    jmlDoctor: 7,
  },
  {
    name: "Urology",
    icon: IcUrology,
    jmlDoctor: 16,
  },
  {
    name: "Neurology",
    icon: IcNeurology,
    jmlDoctor: 18,
  },
  {
    name: "Orthopedic",
    icon: IcOrthopedic,
    jmlDoctor: 22,
  },
];

export default spescialities;
